<template>
  <div v-if="getTemplateList!=null">
    <div class="common-form">模版库</div>
    <div class="min-group">
      <div style="cursor: pointer;padding-top: 5px;padding-bottom: 5px" @click="$parent.onResetPage()">
        <p class="p-txt">我的模版</p>
      </div>
      <div v-for="(item,key) in getTemplateList" :key="key" style="cursor: pointer;padding-top: 5px;padding-bottom: 5px"
           @click="$parent.onAddPageItem(item)">
        <p class="p-txt">{{ item.pageName }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TemplateLib',
  props: {
    templateObject: Object
  },
  data () {
    return {
      templateList: null
    }
  },
  computed: {
    getTemplateList () {
      let templateList = []
      if (this.templateObject) {
        templateList = Object.assign({}, this.templateObject.templateList)
      }
      this.templateList = templateList
      return this.templateList
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/TemplateLib.vue